/* unplugin-vue-components disabled */import { render } from "./TermsAndCondition.vue?vue&type=template&id=6c39ed2e"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__